<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Cotizaciones</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
								<div v-if="!loading && allQuoteList && allQuoteList.length > 0" class="ml-2">
									<b-button variant="link"
											  class="text-success"
											  @click="exportToExcel"
											  v-b-tooltip.hover title="Descargar listado en Formato Excel">
										<i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body class="table-responsive">
						<b-tabs>
							<b-tab title="Pendientes de Aprobación" active class="table-responsive">
								<b-table :items="quotePendingList"
										 :current-page="pendingCurrentPage"
										 :per-page="perPage"
										 :fields="tableFields"
										 :busy="loading"
										 show-empty
										 striped
										 empty-filtered-text="No hay cotizaciones pendientes disponibles"
										 empty-text="No hay cotizaciones pendientes disponibles"
										 head-variant="light">
									<template v-slot:table-busy>
										<div class="text-center text-info my-2">
											<b-spinner class="align-middle"></b-spinner>
										</div>
									</template>

									<div slot="CreatedOn" slot-scope="item">
										{{item.item.CreatedOn | dateFormatFull}}
									</div>

									<div slot="TotalAmount" slot-scope="item">
										{{item.item.Currency}}{{item.item.TotalAmount | formatPrice}}
									</div>
									<div slot="Detail" slot-scope="item">
										<router-link :to="{name: 'QuoteDetail', params: {id: item.item.Id}}">
											Ver
										</router-link>
									</div>
								</b-table>
								<nav class="d-flex justify-content-center" v-if="quotePendingList.length > perPage">
									<b-pagination
										:total-rows="quotePendingList.length"
										:per-page="perPage"
										v-model="pendingCurrentPage"
										prev-text="<<"
										next-text=">>"
										hide-goto-end-buttons/>
								</nav>
							</b-tab>
							<b-tab title="En Proceso" class="table-responsive">
								<b-table :items="quoteList"
										 :current-page="currentPage"
										 :per-page="perPage"
										 :fields="tableFields"
										 :busy="loading"
										 show-empty
										 striped
										 empty-filtered-text="No hay cotizaciones en proceso disponibles"
										 empty-text="No hay cotizaciones en proceso disponibles"
										 head-variant="light">
									<template v-slot:table-busy>
										<div class="text-center text-info my-2">
											<b-spinner class="align-middle"></b-spinner>
										</div>
									</template>

									<div slot="CreatedOn" slot-scope="item">
										{{item.item.CreatedOn | dateFormatFull}}
									</div>

									<div slot="TotalAmount" slot-scope="item">
										{{item.item.Currency}}{{item.item.TotalAmount | formatPrice}}
									</div>
									<div slot="Detail" slot-scope="item">
										<router-link :to="{name: 'QuoteDetail', params: {id: item.item.Id}}">
											Ver
										</router-link>
									</div>
								</b-table>
								<nav class="d-flex justify-content-center" v-if="totalQuotesRows > perPage">
									<b-pagination
										:total-rows="totalQuotesRows"
										:per-page="perPage"
										v-model="currentPage"
										prev-text="<<"
										next-text=">>"
										hide-goto-end-buttons/>
								</nav>
							</b-tab>
							<b-tab title="Histórico" class="table-responsive">
								<b-table :items="quoteHistoryList"
										 :current-page="historyCurrentPage"
										 :per-page="perPage"
										 :fields="tableFields"
										 :busy="loading"
										 show-empty
										 striped
										 empty-filtered-text="No hay cotizaciones disponibles"
										 empty-text="No hay cotizaciones disponibles"
										 head-variant="light">
									<template v-slot:table-busy>
										<div class="text-center text-info my-2">
											<b-spinner class="align-middle"></b-spinner>
										</div>
									</template>

									<div slot="CreatedOn" slot-scope="item">
										{{item.item.CreatedOn | dateFormatFull}}
									</div>

									<div slot="TotalAmount" slot-scope="item">
										{{item.item.Currency}}{{item.item.TotalAmount | formatPrice}}
									</div>
									<div slot="Detail" slot-scope="item">
										<router-link :to="{name: 'QuoteDetail', params: {id: item.item.Id}}">
											Ver
										</router-link>
									</div>
								</b-table>
								<nav class="d-flex justify-content-center" v-if="totalHistoryQuotesRows > perPage">
									<b-pagination
										:total-rows="totalHistoryQuotesRows"
										:per-page="perPage"
										v-model="historyCurrentPage"
										prev-text="<<"
										next-text=">>"
										hide-goto-end-buttons/>
								</nav>
							</b-tab>
						</b-tabs>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState} from "vuex";
	import XLSX from "xlsx";

	export default {
		name: "QuoteList",
		components: {
			AccountDetailComponent,
			GoBackComponent
		},
		data: function () {
			return {
				loading: false,
				quoteList: [],
				quotePendingList: [],
				quoteHistoryList: [],
				allQuoteList: [],
				perPage: 10,
				currentPage: 1,
				historyCurrentPage: 1,
				pendingCurrentPage: 1,
				tableFields: {
					Number: {
						label: 'Id Cotización'
					},
					CreatedOn: {
						label: 'Fecha de Creación'
					},
					Name: {
						label: 'Nombre'
					},
					IncidentNumber: {
						label: 'Caso'
					},
					State: {
						label: 'Estado'
					},
					TotalAmount: {
						label: 'Total',
						key: 'TotalAmount'
					},
					Detail: {
						label: 'Detalles'
					}
				}
			}
		},
		mounted() {
			if (this.accountSelected !== '') {
				this.getQuotes();

			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			getQuotes() {
				this.loading = true;

				this.$store.dispatch('getQuotes')
					.then((quotes) => {
						var that = this;
						quotes.forEach(function (quote) {
							if (quote.StateCode === 0 || quote.StatusCode === 1) {
								that.quotePendingList.push(quote);
							} else if (quote.StateCode === 1 || quote.StatusCode === 2) {
								that.quoteList.push(quote);
							} else if (quote.StateCode === 2 || quote.StatusCode === 4 || quote.StateCode === 3 || quote.StatusCode === 6) {
								that.quoteHistoryList.push(quote);
							}
							/*else {
								that.quoteHistoryList.push(quote);
							}*/
						});

						// this.allQuoteList = quotes;
						console.log(this.quotePendingList.length);
					})
					.catch((error) => {
						console.log(error);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			},
			exportToExcel() {
				let newList = this.allQuoteList.map(function (obj) {
					return {
						'Id Cotización': obj.Number,
						'Fecha Creación': obj.CreatedOn,
						'Nombre': obj.Name,
						'Caso': obj.IncidentNumber,
						'Estado': obj.State,
						'Total': obj.Currency ? obj.Currency + obj.TotalAmount : obj.TotalAmount
					};
				});

				let data = XLSX.utils.json_to_sheet(newList);
				const workbook = XLSX.utils.book_new();
				const filename = 'cotizaciones';
				XLSX.utils.book_append_sheet(workbook, data, filename);
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected
			}),
			totalQuotesRows: function () {
				return this.quoteList.length;
			},
			totalHistoryQuotesRows: function () {
				return this.quoteHistoryList.length;
			},
			totalPendingQuotesRows: function () {
				return this.quotePendingList.length;
			}
		}
	}
</script>

<style scoped>

</style>
